import classnames from 'classnames';
import React from 'react';
import { Button, Card, CardGroup } from 'react-bootstrap';
import CheckIcon from 'v2/icons/CheckIcon';
import bottomLeftYellowBgImage from 'v2/images/bottomLeftYellowBgImage.svg';
import styles from './signUpSubscription.module.scss';
import { useFreeUser } from 'v2/hooks/useFreeUser';
import SubscriptionUpsellEnterprise from './SubscriptionUpsellEnterprise';

interface SignUpSubscriptionProps {
  onSubmit: () => void;
  className?: string;
}

export const LEFT_SIDE_LIST = [
  '$300 / mo',
  '3 simultaneous searches',
  'No monthly search caps',
  'No long-term commitment',
  'No hidden transaction fees',
  'Anonymity features',
];

const SignUpSubscription = ({ onSubmit }: SignUpSubscriptionProps) => {
  const [isFreeUser] = useFreeUser();

  return (
    <CardGroup>
      <Card className={classnames('p-5 shadow-sm border-right-0', styles.root)}>
        <img
          className={styles.bottomLeftYellowBgImage}
          src={bottomLeftYellowBgImage}
          alt="bottomLeftYellowBgImage"
        ></img>
        <div className="z-index-1">
          <h1 className="mt-3">
            Upgrade to Pro to
            <br />
            meet providers today.
          </h1>
          <ul className={classnames(styles.listContainer, 'mt-5 pl-3')}>
            {LEFT_SIDE_LIST.map((item) => (
              <li key={item} className="mb-4">
                <CheckIcon size={16} className="mr-4" />
                <span className={styles.text}>{item}</span>
              </li>
            ))}
          </ul>
          <div
            className={classnames(styles.leftButton, {
              'position-absolute': isFreeUser,
            })}
          >
            <Button className="mt-5 px-4" onClick={onSubmit}>
              Subscribe today!
            </Button>
          </div>
        </div>
      </Card>
      {isFreeUser && <SubscriptionUpsellEnterprise />}
    </CardGroup>
  );
};

export default SignUpSubscription;
